<template>
  <div v-if="(Object.keys(device).length !== 0 && device.constructor === Object)">
    <b-row>
      <b-col>
        <b-card>
          <h1 class="mt-0 mb-0">
            {{ device.name }}
          </h1>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-tabs>
          <b-tab
            :active="activeTab === 'device-details'"
            title="Device Details"
            @click="changeTab('device-details')"
          >
            <device-details
              class="mt-2"
              :device="device"
              :sensors="sensors"
              :objects="workspaceObjects"
              :workspacetoken="workspacetoken"
              @saveDeviceDetails="saveDeviceDetails"
            />
          </b-tab>

          <b-tab
            title="Sensor Data"
            :active="activeTab === 'sensor-data'"
            @click="changeTab('sensor-data')"
          >
            <device-sensor-data
              v-if="Object.keys(device).length > 0 && sensors.length > 0"
              class="mt-2"
              :device="device"
              :sensors="sensors"
              :workspace="workspace"
              :workspacetoken="workspacetoken"
            />
          </b-tab>

        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { API } from 'aws-amplify'
import {
  BTabs,
  BTab,
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import * as queries from '../../../graphql/queries'
import * as mutations from '../../../graphql/mutations'
import DeviceDetails from './DeviceDetails.vue'
import DeviceSensorData from './DeviceSensorData.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    BRow,
    BCol,
    DeviceSensorData,
    DeviceDetails,
  },
  data() {
    return {
      workspace: '',
      workspacetoken: '',
      device: {},
      sensors: [],
      sensorData: [],
      lastSensorData: {},
      workspaceObjects: [],
      activeTab: 'device-details',
    }
  },
  watch: {
    $route: {
      immediate: true, // enables the watcher to run on component creation
      handler(to) {
        if (to.params.tab === 'sensor-data') {
          this.activeTab = 'sensor-data'
        } else {
          this.activeTab = 'device-details'
        }
      },
    },
    device: {
      immediate: true,
      handler() {
        this.updateBreadcrumb(this.device.name)
      },
    },
  },
  async created() {
    this.getWorkspace()
    this.getDevice()
      .then(() => {
        this.updateBreadcrumb(this.device.name)
      })
  },
  methods: {
    changeTab(tab) {
      this.activeTab = tab
      if (tab === 'device-details') {
        this.$router.push(`/devices/${this.$route.params.id}`)
      } else if (tab === 'sensor-data') {
        this.$router.push(`/devices/${this.$route.params.id}/sensor-data`)
      }
    },
    updateBreadcrumb(deviceName) {
      this.$nextTick(() => {
        this.$route.meta.breadcrumb = [
          {
            text: 'Devices',
            to: '/devices',
            active: false,
          },
          {
            text: `${deviceName}`,
            active: true,
          },
        ]
      })
    },
    // --- FUNCTIONS ---
    async getWorkspace() {
      this.workspace = JSON.parse(localStorage.getItem('workspace')).id
      await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: this.workspace,
        },
      }).then(response => {
        if (!response.errors) {
          this.workspacetoken = response.data.getWorkspace.workspacetoken
          this.workspaceObjects = response.data.getWorkspace.objects.items
        }
      })
    },
    async getDevice() {
      try {
        const response = await API.graphql({
          query: queries.getDevice,
          variables: {
            id: this.$route.params.id,
          },
        })
        if (!response.errors) {
          this.device = response.data.getDevice
          this.listSensors(this.device.deviceModel.id)
        }
      } catch (error) {
        // console.error(error)
      }
    },
    async listSensors(deviceModelID) {
      await API.graphql({
        query: queries.listDeviceModelSensors,
        variables: {
          filter: { deviceModelID: { eq: deviceModelID } },
        },
      }).then(response => {
        response.data.listDeviceModelSensors.items.forEach(item => {
          this.sensors.push(item.sensor)
        })
      })
    },

    async saveDeviceDetails(device) {
      // No suppport for PUT request in API
      /*
      const query = {
        'Content-Type': 'application/json',
        network: this.device.network.networkType.identifier,
        apiKey: this.device.network.api_key,
      }
      const body = {
        id: this.device.id,
        name: this.device.name,
      }
      try {
        const postResult = API.put('NetworkAPI', '/devices', {
          queryStringParameters: query,
          body,
        })
        // console.log(postResult)
      } catch (error) {
        // console.log(error)
      }
      */

      const deviceInfo = {
        id: device.id,
        name: device.name,
        manufacturerSerialNumber: device.manufacturerSerialNumber,
      }
      if (device.object) {
        deviceInfo.objectDevicesId = device.object.id
      }
      await API.graphql({
        query: mutations.updateDevice,
        variables: {
          input: deviceInfo,
        },
      }).then(response => {
        if (!response.errors) {
          this.device = response.data.updateDevice
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: `Device 
              ${this.device.name}`
              + ' updated',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/pages/page-profile.scss';
kbd {
  color: #3e3434
}

</style>
